export default {"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20};